import { render, staticRenderFns } from "./CreateAwards.vue?vue&type=template&id=b40efa96&scoped=true"
import script from "./CreateAwards.vue?vue&type=script&lang=js"
export * from "./CreateAwards.vue?vue&type=script&lang=js"
import style0 from "./CreateAwards.vue?vue&type=style&index=0&id=b40efa96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40efa96",
  null
  
)

export default component.exports